import { Box, SimpleGrid, Text, Icon, Center, Heading } from "@chakra-ui/react";
import { FaBullseye, FaUsers, FaTools } from "react-icons/fa";
import Reveal from "./motion";
import { HomeContent } from "../data/homeContent";

const icons = [FaBullseye, FaUsers, FaTools];

type FeaturesProps = { about: HomeContent["about"] };

const Features = ({ about }: FeaturesProps) => (
  <Box
    as="section"
    id="about"
    py={{ base: 20, md: 28 }}
    maxW="1400px"
    mx="auto"
    px={{ base: 5, md: 8 }}
  >
    <Reveal textAlign="center" maxW="700px" mx="auto">
      <Text color="lime.700" fontWeight="bold" fontSize="sm" letterSpacing="wide" mb={3}>
        {about.eyebrow}
      </Text>
      <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }} mb={5}>
        {about.heading}
      </Heading>
      <Text color="slate.700" fontSize={{ base: "sm", md: "md" }}>
        {about.intro}
      </Text>
    </Reveal>

    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mt={16}>
      {about.items.map((feature, i) => (
        <Reveal key={feature.title} delay={i * 0.12}>
          <Box
            position="relative"
            p={7}
            h="100%"
            borderRadius="xl"
            border="1px solid"
            borderColor="chalk.400"
            bg="chalk.50"
            boxShadow="0 4px 20px rgba(20, 37, 26, 0.04)"
            overflow="hidden"
            transition="transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease"
            _hover={{
              transform: "translateY(-6px)",
              borderColor: "lime.500",
              boxShadow: "0 12px 30px rgba(20, 37, 26, 0.08)",
            }}
          >
            <Text
              position="absolute"
              top={2}
              right={4}
              fontFamily="heading"
              fontSize="7xl"
              fontWeight="bold"
              color="chalk.300"
              lineHeight={1}
              userSelect="none"
            >
              {String(i + 1).padStart(2, "0")}
            </Text>
            <Center
              w={12}
              h={12}
              borderRadius="lg"
              bg="chalk.200"
              border="1px solid"
              borderColor="lime.500"
              mb={5}
            >
              <Icon as={icons[i]} w={5} h={5} color="lime.700" />
            </Center>
            <Text fontSize="xl" fontWeight="bold" fontFamily="heading" mb={3}>
              {feature.title}
            </Text>
            <Text color="slate.700" fontSize="sm" lineHeight="1.7">
              {feature.description}
            </Text>
          </Box>
        </Reveal>
      ))}
    </SimpleGrid>
  </Box>
);

export default Features;
